import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import AccordionMenuItem from './AccordionMenuItem'

function ExtraMenu({items=[], currentKey=[], onChange, isOpen}) {
  const [ openedKey, setOpenedKey ] = useState(null)

  const handleChange = (key, item) => {
    if(onChange){
      if(key.length === 1){
        onChange(key, item)
      }else{
        onChange(key, item)
      }
    }
  }

  const handleOpen = (key, item) => {
    setOpenedKey(prevState => prevState === key ? null : key)
  }

  const renderItem = ({item, index, parentItem}) => {
    switch (item.type) {
      case 'accordion':
        return(
          <AccordionMenuItem 
            item={item}
            index={index}
            isOpen={isOpen}
            currentKey={currentKey}
            handleOpen={handleOpen}
            openedKey={openedKey}
            renderItem={renderItem}
            
          />
        )
      case 'submenu': 
        return(
          <NavLink 
            key={`submenu-${item.key}-${index}`}
            to={item.to}                  
            className={`flex items-center whitespace-nowrap rounded py-2 ${currentKey[1] === item.key ? 'bg-primary-200' : ' hover:bg-primary-200'} cursor-pointer`} 
            onClick={() => handleChange([parentItem.key, item.key], item)}
          >
            { item.icon ?
              <>
                <span className='flex pl-[32px]'>{item.icon}</span>
                <span className='ml-3'>{item.label}</span>
              </>
              :
              <span className='ml-[52px]'>{item.label}</span>
            }
          </NavLink>
        )
      case 'divider': 
        return <div className='border-b w-full' key={`${item.key}-${index}`}></div>
      default:
        return(
          <NavLink
            to={item.to}
            key={`${item.key}-${index}`}
            className={`w-full flex items-center whitespace-nowrap rounded hover:bg-extramenu-300  cursor-pointer ${currentKey[0] === item.key ? 'bg-extramenu-300' : ''}`}
            onClick={() => handleChange([item.key], item)}
          >
            { item.icon ? 
              <>
                <span className='flex p-2 {pl-40px}'>{item.icon}</span> 
                <span className='ml-3'>{item.label}</span>
              </>
              :
              <span className='{ml-[68px]}'>{item.label}</span>
            }
          </NavLink>
        )
    }
  }

  return (
    <div className='extraMenu'>
      <div className='overflow-y-auto overflow-x-hidden '>
        { items.map((item, index) => renderItem({item, index})) }
      </div>
    </div>
  )
}

export default ExtraMenu